import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { GetData } from "contexts/DataContext";

import React, { useEffect } from "react";

export function CameraField(props) {
  const { dataObj, setDataObj } = GetData();
  const [value, setValue] = React.useState(() =>
    dataObj?.cameraType !== "front" ? 1 : 0
  );

  useEffect(() => {
    setValue(dataObj?.cameraType !== "front" ? 1 : 0);
  }, [dataObj?.cameraType]);

  const handleChange = (event, newValue) => {
    let cameraType = event.target.value === 1 ? "main" : "front";
    setDataObj(cameraType, "cameraType");
    setValue(event.target.value);
  };

  if (dataObj?.payType !== "self-service") return;

  return (
    <React.Fragment>
      <FormControl fullWidth variant="standard">
        <InputLabel id="camera-type-label" sx={{ paddingTop: "6px" }}>
          Камера
        </InputLabel>
        <Select
          id="camera-type-select"
          label="Камера"
          labelId="camera-type-label"
          onChange={handleChange}
          value={value}
        >
          <MenuItem value={0}>Фронтальная</MenuItem>
          <MenuItem value={1}>Основная</MenuItem>
        </Select>
      </FormControl>
    </React.Fragment>
  );
}
